module.exports = __webpack_public_path__ + "media/images/CM-logo-c8da9974b017bc45b6fa70b200c03d50.png";